import { NETWORK_PATH, NETWORK_REQUEST_PATH } from '../../constants'
import getRequestsNetworkSelect from '../../selectors/get-requests'
import { getPathNetworkUtil } from '../get-path'
import { getStatusNetworkUtil } from '../get-status'
import { isEqualNetworkUtil } from '../is-equal'
import { REDUX_KEY } from '../../../redux/constants/key'
import REDUX_STATUS from '../../../redux/constants/status'
import setUtil from '../../../../utils/set'

function addRequestNetworkUtil (params) {
  const {
    action
  } = params

  let {
    state
  } = params

  const status = (
    getStatusNetworkUtil({ action }, state) || REDUX_STATUS.SAVING
  )

  const requests = getRequestsNetworkSelect(state)
  if (requests.find(request => isEqualNetworkUtil(
    request,
    { action },
    state
  ))) {
    return state
  }

  const request = {
    [NETWORK_REQUEST_PATH.RETRY_COUNT]: 0,
    [NETWORK_REQUEST_PATH.ACTION]: {
      ...action
    }
  }

  state = setUtil(state,
    `${getPathNetworkUtil(request)}.${REDUX_KEY.STATUS}`,
    status
  )

  return setUtil(state, NETWORK_PATH.REQUESTS, [
    ...requests,
    request
  ])
}

export default addRequestNetworkUtil
